<template>
  <div :class="componentClassName">
    <div class="t-sf-default-layout__nav">
      <o-sf-sidebar
        :navigation-items="navigationItems"
        :current-active-item-id="activeNavId"
        :current-user-info="currentUserInfo"
        :handle-online-status-change="handleOnlineStatusChange"
        :handle-logout="handleLogout"
        :username="username"
        :company-i-d="companyID"
      ></o-sf-sidebar>
    </div>
    <div class="t-sf-default-layout__main">
      <m-sf-current-user-status
        v-if="currentUserInfo"
        :online="currentUserInfo.online"
        :business-hour="currentUserInfo.business_hour"
        :user-name="currentUserInfo.name"
        :company-id="currentUserInfo.company_id"
        :edit-profile-url="currentUserInfo.edit_profile_url"
        :logout-url="currentUserInfo.logout_url"
        :phone-number="currentUserInfo.phone_number"
        :auth-info="currentUserInfo.auth_info"
        :handle-online-status-change="handleOnlineStatusChange"
        :handle-logout="handleLogout"
      />
      <slot></slot>
    </div>
    <o-sf-calling-modal
      v-if="currentCallInfo"
      :is-fullscreen="currentCallInfo.isFullscreen"
      :microphone-list-options="currentCallInfo.microphoneListOptions"
      :speaker-list-options="currentCallInfo.speakerListOptions"
      :microphone="currentCallInfo.microphone"
      :speaker="currentCallInfo.speaker"
      :handle-microphone-selection-change="currentCallInfo.handleMicrophoneSelectionChange"
      :handle-speaker-selection-change="currentCallInfo.handleSpeakerSelectionChange"
      :status="currentCallInfo.status"
      :calling-time="currentCallInfo.callingTime"
      :response-status-list="currentCallInfo.responseStatusList"
      :customer-info="currentCallInfo.customerInfo"
      :pending-active-id="currentCallInfo.pendingActiveId"
      :pending-available-list="currentCallInfo.pendingAvailableList"
      :memo="currentCallInfo.memo"
      :user-list="currentCallInfo.userList"
      :forwarding-user-list="currentCallInfo.forwardingUserList"
      :handle-call-history-button-click="currentCallInfo.handleCallHistoryButtonClick"
      :handle-contact-list-button-click="currentCallInfo.handleContactListButtonClick"
      :handle-hold-button-click="currentCallInfo.handleHoldButtonClick"
      :handle-transfer-call-submit="currentCallInfo.handleTransferCallSubmit"
      :handle-numpad-click="currentCallInfo.handleNumpadClick"
      :handle-end-call-button-click="currentCallInfo.handleEndCallButtonClick"
      :handle-end-form-submit="currentCallInfo.handleEndFormSubmit"
      :handle-onhold-activate-button-click="currentCallInfo.handleOnholdActivateButtonClick"
      :handle-onhold-deactivate-button-click="currentCallInfo.handleOnholdDeactivateButtonClick"
      :is-loading="currentCallInfo.isLoading"
      :is-transfer-count-exceeded="currentCallInfo.isTransferCountExceeded"
      :is-hold-count-exceeded="currentCallInfo.isHoldCountExceeded"
      :is-transfer-ok="currentCallInfo.isTransferOk"
      :current-user-info="currentUserInfo"
      :push-number-setting-name="currentCallInfo.pushNumberSettingName"
      :is-acw="currentCallInfo.isAcw"
      :handle-close-call="currentCallInfo.handleCloseCall"
      :created-case-id="currentCallInfo.createdCaseId"
      :sf-current-info="currentCallInfo.sfCurrentInfo"
      :tel-number-info="currentCallInfo.telNumberInfo"
      :current-call-sid="currentCallSid"
      @update-client-list="updateClientList"
      @update-calling-modal-fullscreen="changeFullscreenState"
      @update-memo-empty-status="changeMemoEmptyStatus"
    />
    <o-sf-incoming-call-modal
      v-if="currentIncomingCallInfo"
      :customer-info="currentIncomingCallInfo.customerInfo"
      :response-status-list="currentIncomingCallInfo.responseStatusList"
      :has-new-call="currentIncomingCallInfo.hasNewCall"
      :has-new-on-hold="currentIncomingCallInfo.hasNewOnHold"
      :onhold-list="currentIncomingCallInfo.onholdList"
      :handle-incoming-call-tab-change="currentIncomingCallInfo.handleIncomingCallTabChange"
      :handle-reject-call-click="currentIncomingCallInfo.handleRejectCallClick"
      :handle-receive-call-click="currentIncomingCallInfo.handleReceiveCallClick"
      :handle-onhold-button-click="currentIncomingCallInfo.handleOnholdButtonClick"
      :sf-cases="currentIncomingCallInfo.sfCases"
      :sf-contact-info="currentIncomingCallInfo.sfContactInfo"
      :push-number-setting-name="currentIncomingCallInfo.pushNumberSettingName"
      :tel-number-info="currentIncomingCallInfo.telNumberInfo"
    />
    <o-incoming-call-modal v-if="!currentIncomingCallInfo && !currentCallInfo" />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import MSfCurrentUserStatus from '@/components/molecules/sf-current-user-status';
import OSfCallingModal from '@/components/organisms/sf-calling-modal';
import OSfIncomingCallModal from '@/components/organisms/sf-incoming-call-modal';
import OSfSidebar from '@/components/organisms/sf-sidebar';
import { NAVIGATION_ITEMS } from '@/libs/constants';
import { POINT } from '@/libs/constants';

import { utils } from '@/common/utils.js';

export default {
  name: 't-sf-default-layout',
  components: {
    MSfCurrentUserStatus,
    OSfCallingModal,
    OSfIncomingCallModal,
    OSfSidebar,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    activeNavId: {
      type: String,
      default: '',
    },
    currentCallInfo: {
      type: Object,
      default: null,
    },
    currentIncomingCallInfo: {
      type: Object,
      default: null,
    },
    handleOnlineStatusChange: {
      type: Function,
      default: () => {},
    },
    handleLogout: {
      type: Function,
      default: () => {},
    },
    username: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    userID: {
      type: String,
      default: '',
    },
    memo: {
      type: String,
      default: '',
    },
    currentUserInfo: {
      type: Object,
      default: null,
      //default: {},
    },
    currentCallSid: {
      type: String,
      default: '',
    },
  },
  emits: ['update-client-list', 'update-calling-modal-fullscreen', 'update-memo-empty-status'],
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-sf-default-layout');
      return `${baseClassName} ${this.class}`.trim();
    },
    navigationItems() {
      const navigationItems = NAVIGATION_ITEMS;
      if (this.isGeneralUser) {
        const navigationItemsIndex = navigationItems.findIndex(({ nav_id }) => nav_id === 'settings');
        navigationItems[navigationItemsIndex].items = navigationItems[navigationItemsIndex].items.filter(
          item =>
            item.nav_id !== 'settings-company-list' &&
            item.nav_id !== 'settings-request' &&
            // item.nav_id !== 'price-history-list-mgmt' &&
            item.nav_id !== 'number-mgmt' &&
            item.nav_id !== 'number-mgmt-fdnd' // #3112
        );
      }

      // メニュー表示判別処理
      for (let i = 0; i < navigationItems.length; i++) {
        // 発着信履歴
        if (navigationItems[i].nav_id === 'call_history') {
          if (this.isSoOperator) {
            navigationItems.splice(i, 1);
          }
        }

        // 連絡先
        if (navigationItems[i].nav_id === 'contact') {
          if (this.isSoOperator) {
            navigationItems.splice(i, 1);
          }
        }

        // 設定
        if (navigationItems[i].nav_id === 'settings') {
          navigationItems[i] = this.processSettingNavItems(navigationItems[i]);
        }
      }

      return navigationItems;
    },
    isComUser() {
      return this.currentUserInfo.company_id === POINT;
    },
    isGeneralUser() {
      return this.currentUserInfo.company_id !== POINT;
    },
    isOperator() {
      return this.currentUserInfo.auth_info === 'operator';
    },
    isSoOperator() {
      return this.currentUserInfo.auth_info === 'soOperator';
    },
    isComOperator() {
      return this.isComUser && this.isOperator;
    },
    isComSoOperator() {
      return this.isComUser && this.isSoOperator;
    },
    isGeneralOperator() {
      return this.isGeneralUser && this.isOperator;
    },
  },
  methods: {
    processSettingNavItems(settings) {
      for (let j = 0; j < settings.items.length; j++) {
        // 料金状況
        if (settings.items[j].nav_id === 'price-history-list') {
          // 003300のオペレーター権限（SO）と003300以外のオペレーター権限は非表示
          if (this.isComSoOperator || this.isGeneralOperator) {
            settings.items.splice(j, 1);
          }
        }

        // 料金状況管理
        if (settings.items[j].nav_id === 'price-history-list-mgmt') {
          // 003300のオペレーター権限と003300以外は非表示
          if (this.isComOperator || this.isGeneralUser) {
            settings.items.splice(j, 1);
          }
        }

        // 営業時間設定
        if (settings.items[j].nav_id === 'settings-business-hours') {
          // 003300のオペレーター権限（SO）は非表示
          if (this.isComSoOperator) {
            settings.items.splice(j, 1);
          }
        }

        // 着信フロー設定
        if (settings.items[j].nav_id === 'settings-incoming-flows') {
          // 003300のオペレーター権限（SO）は非表示
          if (this.isComSoOperator) {
            settings.items.splice(j, 1);
          }
        }

        // 契約情報確認・変更
        if (settings.items[j].nav_id === 'settings-contract') {
          // 003300のオペレーター権限（SO）と003300以外のオペレーター権限は非表示
          if (this.isComSoOperator || this.isGeneralOperator) {
            settings.items.splice(j, 1);
          }
        }

        // 企業情報管理
        if (settings.items[j].nav_id === 'settings-company-list') {
          // 003300以外は非表示
          if (this.isGeneralUser) {
            settings.items.splice(j, 1);
          }
        }

        // 申し込み管理
        if (settings.items[j].nav_id === 'settings-request') {
          // 003300以外は非表示
          if (this.isGeneralUser) {
            settings.items.splice(j, 1);
          }
        }

        // 電話番号管理
        if (settings.items[j].nav_id === 'number-mgmt') {
          // 003300以外は非表示
          if (this.isGeneralUser) {
            settings.items.splice(j, 1);
          }
        }

        // #3112
        // FD/ND番号管理
        if (settings.items[j].nav_id === 'number-mgmt-fdnd') {
          // 003300のオペレーター権限と003300以外は非表示
          if (this.isComOperator || this.isGeneralUser) {
            settings.items.splice(j, 1);
          }
        }

        // 電話番号管理(一般ユーザー用)
        if (settings.items[j].nav_id === 'number-mgmt-general') {
          // オペレーター権限と003300は非表示
          // #3445 トライアルユーザも非表示
          if (this.isComUser || this.isOperator || utils.chkTrialCompanyID(this.currentUserInfo.company_id)) {
            settings.items.splice(j, 1);
          }
        }

        // #2945
        // トライアル管理
        if (settings.items[j].nav_id === 'settings-trial') {
          // 003300以外は非表示
          if (this.isGeneralUser) {
            settings.items.splice(j, 1);
          }
        }
      }
      return settings;
    },
    updateClientList() {
      this.$emit('update-client-list');
      //this.$emit('update-client-list');
    },
    changeFullscreenState(flag) {
      this.$emit('update-calling-modal-fullscreen', flag);
    },
    changeMemoEmptyStatus(flag) {
      this.$emit('update-memo-empty-status', flag);
    },
  },
};
</script>
